import React, { useEffect, useRef } from 'react';
import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';

const { TextArea } = Input;
interface TextAreaPlusProps extends TextAreaProps {
  edited?: boolean;
  outline?: boolean;
}
/**
 * Extend the TextArea component
 * Feature:Support readonly status
 */
export default function TextAreaPlus(props: TextAreaPlusProps): JSX.Element {
  const { edited, autoFocus, outline, ...other } = props;
  const input = useRef(null);
  useEffect(() => {
    if (edited && autoFocus) {
      const textarea = input.current as any;
      textarea.focus();
    }
  }, [edited, autoFocus]);
  if (edited) {
    return (
      <TextArea
        ref={input}
        /* eslint-disable react/jsx-props-no-spreading */
        {...other}
        autoFocus={autoFocus}
      />
    );
  } else {
    return (
      <TextArea
        /* eslint-disable react/jsx-props-no-spreading */
        {...other}
        className={
          outline ? 'form-input-readonly-outline' : 'form-input-readonly'
        }
      />
    );
  }
}
TextAreaPlus.defaultProps = {
  edited: undefined,
  outline: undefined,
};
